/**
 * @description 查詢系統參數用類別
*/
export enum SysOptType {
  /** 車種限制 */
  VEHICLE = 'VEHICLE',
  /** 性別 */
  GENDER = 'GENDER',
  /** 婚姻狀況 */
  MARRIAGE = 'MARRIAGE',
  /** 是否選項 */
  YESNO = 'YESNO',
  /** 保險人數 */
  ONEORMORE = 'ONEORMORE',
  /** 身分別 (本國人/外國人) */
  NATIONALITY = 'NATIONALITY',
  /** 身分別 (本國人/外國人/法人) 車險 */
  NATIONALITYV = 'NATIONALITYV',
  /** 要保人/被保險人 */
  INSROLETYPE = 'INSROLETYPE',
  /** 特定活動類別 */
  SPI = 'SPI',
  /** 交通工具 */
  TRANSPORT = 'TRANSPORT',
  /** 投保對象 */
  INSUREDSUBJECT = 'INSUREDSUBJECT',
  /** 被保險人與要保人關係 */
  RELATION = 'RELATION',
  /** 被保險人與要保人關係-車險 (身分別- 法人) */
  RELATIONL = 'RELATIONL',
  /** 被保險人與要保人關係-車險 (身分別- 本國人、外國人) */
  RELATIONV = 'RELATIONV',
  /** 被保險人與要保人關係-行動裝置險 */
  RELATIONMD = 'RELATIONMD',
  /** 被保險人與要保人關係-旅平險 */
  RELATIONT = 'RELATIONT',
  /** 保單寄送方式 (舊) */
  PODELIVERY = 'PODELIVERY',
  /** 保單寄送方式 (新) */
  PODELIVER_BY = 'PODELIVER_BY',
  /** 保費支付方式 */
  PAYBY = 'PAYBY',
  /** 旅遊險試算頁-身故失能預設保額 */
  EVAL_LIEF_DEFAULT = 'EVAL_LIEF_DEFAULT',
  /** 投保完成頁聯絡資訊 */
  EMAIL_NOTIFY = 'EMAIL_NOTIFY',
  /** 要保書類型 */
  DOC_ID = 'DOC_ID',
  /**  */
  TWCA_SW = 'TWCA_SW',
  TWCA_UG = 'TWCA_UG',
  /** 車輛排氣量單位 */
  VEHICLEPOWER = 'VEHICLEPOWER',
  /** 勘車畫面文字 */
  CARSURVEY = 'CARSURVEY',
  /** 機車險投保年期 */
  MOTOR_COPRD = 'MOTOR_COPRD',
  /** 行動投保必須提供之憑證清單 */
  MDPC = 'MDPC',
  /** 行動投保相關系統參數 */
  MOBDEV = 'MOBDEV',
  /** 行動投保裝置系統參數 */
  MOBDEV_DEVTYPE = 'MOBDEV_DEVTYPE',
  /** 建築物結構 */
  BUILDSTRUCT = 'BUILDSTRUCT',
  /** 屋頂別 */
  ROOFTYPE = 'ROOFTYPE',
  /** 每坪裝潢費用 */
  DECOCOST = 'DECOCOST',
  /** 是否為貸款戶 */
  MORTGAGE_STATUS = 'MORTGAGE_STATUS',
  /** 理賠服務-汽機車險上傳資料 */
  CLAIM_ATT = 'CLAIM_ATT',
  /** 理賠批改-車險投保項目用 */
  VEHICLE_CV_TYPE = 'VEHICLE_CV_TYPE',
  /** 行動裝置險-QRCode */
  PHONEDOCTOR = 'PHONEDOCTOR',
  /** 住火險-批改-可變更項目-門牌證明書樣本連結 */
  ENDORSE_I04 = 'ENDORSE_I04',
  /** 旅平險 */
  TRAVEL = 'TRAVEL',
  INSUREDSUBJECTO = 'INSUREDSUBJECTO',
  INSUREDSUBJECTM = 'INSUREDSUBJECTM',
  CONSTRAINT = 'CONSTRAINT',
  TRAVEL_PERIOD = 'TRAVEL_PERIOD',
  /** 系統參數 */
  SYSTEM = 'SYSTEM',
  BLACKOUT = 'BLACKOUT',
  /** 各類車牌格式正則 */
  PNO_FORMAT = 'PNO_FORMAT',
  /** 多語資源 */
  I18N = 'I18N',
  /** 旅平險-英文投保證明下載 */
  WWUOWS = 'WWUOWS',
  /** 旅平險-說明 Modal 種類名稱 */
  TRAVEL_ELGPT = 'TRAVEL_ELGPT',
  /** 旅平險-要保人年齡限制 */
  TRAVE_APTAGELMT = 'TRAVE_APTAGELMT',
  /** 旅平險-被保人年齡限制 */
  TRAVE_ISUAGELMT = 'TRAVE_ISUAGELMT',
  /** 旅平險-申根一人 */
  SGSUBJECTO = 'SGSUBJECTO',
  /** 旅平險-申根多人 */
  SGSUBJECTM = 'SGSUBJECTM',
  /** LINE綁定連結 */
  LINEBINDINGURL = 'LINEBINDINGURL',
};
